import React from 'react'

import { NAV_BRAND } from '@/config'
import { PORTAL_TYPE_RJA, PORTAL_TYPE_YF } from '@/config/constants'
import Footer from '@/main/components/Footer'
import FooterExtended from '@/main/components/FooterExtended'

import StaticFooter from '../../rjaHomepage/components/StaticFooter'

const CMSFooter = () => {
  if (NAV_BRAND.portal_type === PORTAL_TYPE_YF && !NAV_BRAND.portal_is_at) {
    return <FooterExtended />
  } else if (NAV_BRAND.portal_type === PORTAL_TYPE_RJA) {
    return <StaticFooter />
  }

  return <Footer />
}

export default CMSFooter
